import React from "react";
import { Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";
import CustomBreadcrumb from "../components/breadcrumb/CustomBreadcrumb";
import { useBreadcrumb } from "../store/context/BreadcrumbContext";

const { Content } = Layout;
const MainLayout = () => {
  const location = useLocation();
  const { setBreadcrumb } = useBreadcrumb();

  React.useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);

    if (pathParts[0] === "lottery") {
      const type = pathParts[1];
      setBreadcrumb([
        { title: "Дашбоард", path: "/" },
        {
          title:
            type === "active"
              ? "Идэвхтэй сугалаа"
              : type === "draft"
                ? "Draft сугалаа"
                : type === "completed"
                  ? "Дууссан сугалаа"
                  : "Тайлан",
          path: `/lottery/${type}`,
        },
      ]);
    } else if (pathParts[0] === "ticket") {
      const type = pathParts[1];
      setBreadcrumb([
        { title: "Дашбоард", path: "/" },
        {
          title:
            type === "engagement"
              ? "Оролцоо"
              : type === "draft"
                ? "Draft сугалаа"
                : type === "feedback"
                  ? "Гомдол, Асуудал"
                  : "Тайлан",
          path: `/lottery/${type}`,
        },
      ]);
    } else if (location.pathname.startsWith("/report")) {
      setBreadcrumb([
        { title: "Дашбоард", path: "/dashboard" },
        { title: "Тайлан", path: "/report" },
      ]);
    } else if (pathParts[0] === "reward") {
      if (pathParts.length === 1) {
        setBreadcrumb([
          { title: "Дашбоард", path: "/dashboard" },
          { title: "Урамшуулал", path: "/reward" },
        ]);
      } else {
        setBreadcrumb([
          { title: "Дашбоард", path: "/dashboard" },
          { title: "Урамшуулал", path: "/reward" },
          { title: "Дэлгэрэнгүй" },
        ]);
      }
    } else if (location.pathname.startsWith("/profile")) {
      setBreadcrumb([
        { title: "Дашбоард", path: "/dashboard" },
        { title: "Профайл", path: "/profile" },
      ]);
    } else if (location.pathname.startsWith("/sms")) {
      setBreadcrumb([
        { title: "Дашбоард", path: "/dashboard" },
        { title: "Мессеж", path: "/sms" },
      ]);
    } else if (location.pathname.startsWith("/staff")) {
      setBreadcrumb([
        { title: "Дашбоард", path: "/dashboard" },
        { title: "Ажилтан", path: "/staff" },
      ]);
    } else if (pathParts[0] === "bank") {
      const type = pathParts[1];
      setBreadcrumb([
        { title: "Дашбоард", path: "/" },
        {
          title: type === "account" ? "Банкны данс" : "Дансны хуулга",
          path: `/lottery/${type}`,
        },
      ]);
    } else if (location.pathname.startsWith("/news")) {
      setBreadcrumb([
        { title: "Дашбоард", path: "/dashboard" },
        { title: "Мэдээ мэдээлэл", path: "/news" },
      ]);
    }
    // else if (location.pathname.startsWith("/call-center")) {
    //   setBreadcrumb([
    //     { title: "Дашбоард", path: "/dashboard" },
    //     { title: "Дуудлагын төв", path: "/call-center" },
    //   ]);
    else if (pathParts[0] === "call-center") {
      // /call-center  → жагсаалт
      if (pathParts.length === 1) {
        setBreadcrumb([
          { title: "Дашбоард", path: "/dashboard" },
          { title: "Дуудлагын жагсаалт", path: "/call-center" },
        ]);
      } else {
        // /call-center/:id  → дэлгэрэнгүй
        const id = pathParts[1];
        setBreadcrumb([
          { title: "Дашбоард", path: "/dashboard" },
          { title: "Дуудлагын жагсаалт", path: "/call-center" },
          { title: "Дэлгэрэнгүй" },
        ]);
      }
    } else {
      setBreadcrumb([{ title: "Дашбоард", path: "/dashboard" }]);
    }
  }, [location.pathname, setBreadcrumb]);

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Sidebar />
      <Layout
        style={{
          padding: "10px 30px 10px",
          backgroundColor:
            location.pathname === "/dashboard" ? "#f7f7f7" : "#fff",
          gap: "20px",
          overflow: "auto",
        }}
      >
        <CustomBreadcrumb />
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
